module.exports = __webpack_public_path__ + "media/images/favicon-16x16-c4e519f50c728222aae60291cf981f28.png";